import { gql } from '@apollo/client';

export const ARCHIVED_TOPICS = gql`
  query ArchivedTopics($slug: String!, $after: ID, $limit: Int) {
    space(slug: $slug) {
      id
      topics(archived: true, after: $after, limit: $limit) {
        id
        name
        publicId
        archivedAt
      }
    }
  }
`;

export const COMMENT_VERSIONS = gql`
  query CommentVersions($id: ID!) {
    comment(id: $id) {
      id
      versions {
        id
        publicId
        body
        createdAt
        author {
          id
          name
          avatarUrl
        }
      }
    }
  }
`;

export const SEARCH = gql`
  query Search($spaceSlug: String!, $text: String!) {
    search(spaceSlug: $spaceSlug, text: $text) {
      id
      name
      publicId
    }
  }
`;

export const SPACE = gql`
  query Space(
    $slug: String!
    $assigneeId: ID
    $authorId: ID
    $state: TopicState
    $tagId: ID
    $after: ID
    $limit: Int
  ) {
    space(slug: $slug) {
      id
      bannerUrl
      icon
      name
      slug
      role
      ownerId
      topics(
        assigneeId: $assigneeId
        authorId: $authorId
        state: $state
        tagId: $tagId
        after: $after
        limit: $limit
      ) {
        id
        name
        state
        author {
          id
          name
          avatarUrl
        }
        assignee {
          id
          name
          avatarUrl
        }
        tags {
          id
          name
        }
        createdAt
        publicId
        isPinned
      }
      public
      planLevel
      earlyAccess
      customer
    }
  }
`;

export const SPACE_BY_JOIN_CODE = gql`
  query SpaceByJoinCode($joinCode: String!) {
    spaceByJoinCode(joinCode: $joinCode) {
      name
      slug
      bannerUrl
    }
  }
`;

export const SPACE_JOIN_CODE = gql`
  query SpaceJoinCode($slug: String!) {
    space(slug: $slug) {
      id
      joinCode
    }
  }
`;

export const SPACE_TAGS = gql`
  query SpaceTags($slug: String!) {
    space(slug: $slug) {
      id
      tags {
        id
        name
      }
    }
  }
`;

export const SPACE_MEMBERS = gql`
  query SpaceMembers($slug: String!) {
    space(slug: $slug) {
      id
      members {
        spaceId
        joinedAt
        role
        user {
          id
          name
          avatarUrl
        }
      }
    }
  }
`;

export const TOPIC = gql`
  query Topic($spaceSlug: String!, $publicId: Int!) {
    topic(spaceSlug: $spaceSlug, publicId: $publicId) {
      id
      name
      state
      space {
        id
        name
        slug
        role
      }
      author {
        id
        name
        avatarUrl
      }
      assignee {
        id
        name
        avatarUrl
      }
      comments {
        id
        body
        author {
          id
          name
          avatarUrl
        }
        lastEdited
        publicId
        createdAt
      }
      tags {
        id
        name
      }
      createdAt
      publicId
      isPinned
      archivedAt
    }
  }
`;

export const VIEWER = gql`
  query Viewer {
    viewer {
      id
      name
      email
      avatarUrl
      spaces {
        id
        icon
        name
        slug
        role
        ownerId
      }
      nightMode
      currentSession
    }
  }
`;

export const VIEWER_SESSIONS = gql`
  query ViewerSessions {
    viewer {
      id
      currentSession
      sessions {
        id
        createdAt
        ipAddress
        userAgent
      }
    }
  }
`;
